var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.15583 5H1.69663M1.69663 5L1.02415 7.84477C0.839036 8.62785 1.75351 9.25466 2.559 8.89682L9.40496 5.85546C10.1983 5.50299 10.1983 4.49701 9.40496 4.14454L8.90856 3.92402M1.69663 5L1.02415 2.15523C0.839036 1.37216 1.75351 0.745338 2.559 1.10318L3.79548 1.6525",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6935 1.2353C6.56607 0.921568 6.16121 0.921567 6.03377 1.2353L5.78058 1.85864L5.21391 2.13715C4.9287 2.27733 4.9287 2.72267 5.21391 2.86285L5.78058 3.14136L6.03377 3.7647C6.16121 4.07843 6.56607 4.07843 6.6935 3.7647L6.94669 3.14136L7.51337 2.86285C7.79858 2.72267 7.79858 2.27733 7.51337 2.13715L6.94669 1.85864L6.6935 1.2353Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31082 0.156865C9.22586 -0.0522883 8.95596 -0.0522883 8.871 0.156865L8.7022 0.572425L8.32442 0.7581C8.13428 0.851552 8.13428 1.14845 8.32442 1.2419L8.7022 1.42758L8.871 1.84313C8.95596 2.05229 9.22586 2.05229 9.31082 1.84313L9.47961 1.42758L9.8574 1.2419C10.0475 1.14845 10.0475 0.851552 9.8574 0.7581L9.47961 0.572425L9.31082 0.156865Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterIcon);
export default __webpack_public_path__ + "static/media/enterIcon.8a0053ddf163196fb24c84ed8d05feea.svg";
export { ForwardRef as ReactComponent };